import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Dropdown } from '@flywire/react-headlessui';
import { cx } from '../../utils';
const useButtonClasses = ({ className }) => {
    return cx('inline-flex w-full cursor-pointer items-center justify-center gap-x-2 bg-transparent tracking-normal text-gray-950', className);
};
const ButtonComponent = forwardRef(({ className, ...rest }, ref) => {
    const buttonClasses = useButtonClasses({ className });
    return _jsx(Dropdown.Button, { className: buttonClasses, ref: ref, ...rest });
});
ButtonComponent.displayName = 'Button';
const Button = ButtonComponent;
export { Button };
//# sourceMappingURL=Button.js.map